document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;
    const inscriptionToggle = section.querySelector('#inscription-toggle');
    const inscriptionField = section.querySelector('.productFormInscriptionField');
    const realPriceEl = section.querySelector(".productPriceReal");
    const comparePriceEl = section.querySelector(".productPriceCompare");
    const atcBtn = section.querySelector(".productATC");
    const atcText = section.querySelector(".productATCText");

    /*** Dev Expose ***/
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /*** Swiper Setup ***/
    const thumbsSwiper = new Swiper(section.querySelector('.productVisualThumbs'), {
        slidesPerView: 4,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        breakpoints: {
            0: {slidesPerView: 3},
            600: {slidesPerView: 4}
        }
    });

    const productSwiper = new Swiper(section.querySelector('.productVisualMain'), {
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: section.querySelector('.productVisualArrow.next'),
            prevEl: section.querySelector('.productVisualArrow.prev'),
        },
        thumbs: {swiper: thumbsSwiper},
        on: {
            slideChange: () => {
                section.querySelectorAll('.productVisualMedia video')?.forEach(video => video.pause());
            }
        }
    });

    /*** Variant + Pricing Update ***/
    function updateProduct() {
        if (product.variants.length === 1) {
            activeVariant = product.variants[0];
        } else {
            let options = [];
            section.querySelectorAll('.productFormOptionsItem').forEach(group => {
                const selected = group.querySelector('select')?.value || group.querySelector('input:checked')?.value;
                options.push(selected);
            });
            activeVariant = product.variants.find(v => JSON.stringify(v.options) === JSON.stringify(options));
        }

        if (!activeVariant) {
            atcBtn.disabled = true;
            atcText.textContent = "Not Available";
            return;
        }

        if (activeVariant.featured_image) {
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        const basePrice = activeVariant.price;
        const compareAtPrice = activeVariant.compare_at_price;
        let totalPrice = basePrice;

        if (inscriptionToggle?.checked) {
            totalPrice += 1500; // Add inscription price
        }

        if (realPriceEl) realPriceEl.textContent = price(totalPrice);

        if (comparePriceEl) {
            if (compareAtPrice > basePrice) {
                comparePriceEl.textContent = price(compareAtPrice);
                comparePriceEl.style.display = "inline";
            } else {
                comparePriceEl.style.display = "none";
            }
        }

        atcBtn.disabled = !activeVariant.available;
        atcText.textContent = activeVariant.available ? "Add To Cart" : "Sold Out";

        const url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    updateProduct();

    /*** Quantity Controls ***/
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", () => {
        if (quantity > 1) {
            quantity--;
            section.querySelector(".productQuantityControlsValue").textContent = quantity;
        }
    });

    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", () => {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
    });

    /*** Add to Cart ***/
    atcBtn.addEventListener("click", async () => {
        atcBtn.classList.add("loading");

        const mainItem = {
            quantity,
            id: activeVariant.id,
            properties: {}
        };

        const upsellItems = [];
        const inscriptionUpsellId = 45673302753434; // Replace with your upsell product's variant ID
        let hasMissingRequired = false;

        section.querySelectorAll(".productFormInscriptionField").forEach(field => {
            const input = field.querySelector("input, textarea, select");
            const label = field.querySelector("label")?.textContent?.trim();
            const value = input?.value?.trim();
            const triggersUpsell = field.dataset.upsell === "true";
            const upsellVariantId = field.dataset.upsellVariant;

            if (!label) return;

            if (input?.hasAttribute("required") && !value) {
                input.classList.add("input-error");
                hasMissingRequired = true;
            }

            if (value) {
                mainItem.properties[label] = value;

                if (triggersUpsell && upsellVariantId) {
                    upsellItems.push({
                        quantity: 1,
                        id: Number(upsellVariantId),
                        properties: {
                            "Linked to": product.title,
                            [label]: value
                        }
                    });
                }
            }
        });

        if (hasMissingRequired) {
            Swal.fire({
                title: "Missing Information",
                text: "Please fill in all required fields before continuing.",
                icon: "error"
            });
            atcBtn.classList.remove("loading");
            return;
        }

        try {
            await addProduct({
                items: [
                    mainItem,
                    ...upsellItems
                ]
            });
            await openCart();
        } catch (err) {
            console.error("Error adding to cart:", err);
        } finally {
            atcBtn.classList.remove("loading");
        }
    });


    /*** Watchers ***/
    section.querySelectorAll("input[type='radio'], select").forEach(input => {
        input.addEventListener("change", updateProduct);
    });

    if (inscriptionToggle && inscriptionField) {
        inscriptionToggle.addEventListener('change', () => {
            inscriptionField.style.display = inscriptionToggle.checked ? 'block' : 'none';
            updateProduct();
        });
    }
});


const tabButtons = document.querySelectorAll('.tabHeader button');
const tabPanes = document.querySelectorAll('.tabPane');

tabButtons.forEach(button => {
    button.addEventListener('click', () => {
        const tab = button.dataset.tab;

        tabPanes.forEach(pane => pane.classList.remove('active'));
        tabButtons.forEach(btn => btn.classList.remove('active'));

        document.getElementById(tab).classList.add('active');
        button.classList.add('active');
    });
});